// ProductDetails.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "./axiosInstance";
import ProductReviews from "./ProductReviews";
import AddReview from "./AddReview";

function ProductDetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [reload, setReload] = useState(false); // ⭐ to refresh reviews

  useEffect(() => {
    const load = async () => {
      const res = await API.get(`/products/${id}`);
      setProduct(res.data);
    };
    load();
  }, [id]);

  if (!product) return <h3>Loading...</h3>;

  return (
    <div style={{ padding: "30px" }}>
      <h2>{product.name}</h2>
      <img
        src={product.images?.[0]}
        style={{ width: "300px", borderRadius: "10px" }}
        alt="Product"
      />
      <p>Price: ₹{product.price}</p>
      <p>{product.description}</p>

      <hr />

      {/* ⭐ ALL REVIEWS + refresh trigger */}
      <ProductReviews productId={id} reload={reload} />

      <hr />

      {/* ⭐ ADD REVIEW → pass function to refresh reviews */}
      <AddReview productId={id} onReviewAdded={() => setReload(!reload)} />
    </div>
  );
}

export default ProductDetails;
